import { surveyLocalization } from "survey-core";

export var croatianStrings = {
  pagePrevText: "Prethodni",
  pageNextText: "Sljedeći",
  completeText: "Kompletan",
  previewText: "Pregled",
  editText: "Uređivanje",
  startSurveyText: "Početak",
  otherItemText: "Ostali (opis)",
  noneItemText: "Nitko",
  selectAllItemText: "Select All",
  progressText: "Stranica {0} od {1}",
  panelDynamicProgressText: "Zapisa {0} od {1}",
  questionsProgressText: "Odgovorio na {0}/{1} pitanja",
  emptySurvey: "U anketi nema vidljive stranice ili pitanja.",
  completingSurvey: "Hvala vam što ste završili anketu!",
  completingSurveyBefore:
    "Naši zapisi pokazuju da ste već završili ovu anketu.",
  loadingSurvey: "Anketa o učitavanje...",
  placeholder: "Odaberite...",
  value: "vrijednost",
  requiredError: "Molim vas odgovorite na pitanje.",
  requiredErrorInPanel: "Molim vas odgovorite na barem jedno pitanje.",
  requiredInAllRowsError: "Odgovorite na pitanja u svim redovima.",
  numericError: "Vrijednost bi trebala biti brojčana.",
  textMinLength: "Unesite najmanje {0} znak(ova).",
  textMaxLength: "Unesite manje od {0} znak(ova).",
  textMinMaxLength: "Unesite više od {0} i manje od {1} znakova.",
  minRowCountError: "Molimo ispunite najmanje {0} redaka.",
  minSelectError: "Odaberite barem {0} varijante.",
  maxSelectError: "Odaberite ne više od {0} varijanti.",
  numericMinMax:
    "'{0}'bi trebao biti jednak ili više od {1} i jednak ili manji od {2}.",
  numericMin: "'{0}' bi trebao biti jednak ili više od {1}.",
  numericMax: "'{0}' bi trebao biti jednak ili manji od {1}",
  invalidEmail: "Unesite valjanu e-mail adresu.",
  invalidExpression: "Izraz: {0} treba vratiti 'true'.",
  urlRequestError: "Zahtjev vratio pogrešku '{0}'. {1}",
  urlGetChoicesError:
    "Zahtjev je vratio prazne podatke ili je 'path' svojstvo netočna.",
  exceedMaxSize: "Veličina datoteke ne smije prelaziti {0}.",
  otherRequiredError: "Unesite drugu vrijednost.",
  uploadingFile:
    "Vaša datoteka se prenosi. Pričekajte nekoliko sekundi i pokušajte ponovno.",
  loadingFile: "Učitavanje...",
  chooseFile: "Odaberite datoteku...",
  noFileChosen: "Nije odabrana datoteka",
  confirmDelete: "Želite li izbrisati zapis?",
  keyDuplicationError: "Ta bi vrijednost trebala biti jedinstvena.",
  addColumn: "Dodavanje stupca",
  addRow: "Dodavanje redaka",
  removeRow: "Ukloniti",
  addPanel: "Dodavanje novih",
  removePanel: "Ukloniti",
  choices_Item: "stavku",
  matrix_column: "Stupca",
  matrix_row: "Redak",
  savingData: "Rezultati se spremaju na poslužitelju...",
  savingDataError: "Došlo je do pogreške i nismo mogli spremiti rezultate.",
  savingDataSuccess: "Rezultati su uspješno spremljeni!",
  saveAgainButton: "Pokušaj ponovo",
  timerMin: "min",
  timerSec: "sec",
  timerSpentAll: "Vi ste proveli {0} na ovoj stranici i {1} ukupno.",
  timerSpentPage: "Potrošili ste {0} na ovu stranicu.",
  timerSpentSurvey: "You have spent {0} in total. {0}.",
  timerLimitAll:
    "Vi ste proveli {0} od {1} na ovoj stranici i {2} od {3} ukupno.",
  timerLimitPage: "Potrošio si {0} od {1} na ovoj stranici.",
  timerLimitSurvey: "Ukupno ste potrošili {0} od {1}.",
  cleanCaption: "Očistiti",
  clearCaption: "Očistiti",
  chooseFileCaption: "Odaberite datoteku",
  removeFileCaption: "Uklonite ovu datoteku",
  booleanCheckedLabel: "Da",
  booleanUncheckedLabel: "Ne",
  confirmRemoveFile: "Jeste li sigurni da želite ukloniti ovu datoteku: {0}?",
  confirmRemoveAllFiles: "Jeste li sigurni da želite ukloniti sve datoteke?",
  questionTitlePatternText: "Naslov pitanja",
  modalCancelButtonText: "Otkazati",
  modalApplyButtonText: "Primijeniti",
};

surveyLocalization.locales["hr"] = croatianStrings;
surveyLocalization.localeNames["hr"] = "hrvatski";
